// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".frisbuy-popup-with-slot[data-v-6ac8a6e9]{z-index:99999999999999}.frisbuy-popup-with-slot .frisbuy-video-wrapper[data-v-6ac8a6e9]{padding-bottom:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
